'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ArrowMarker = require('./ArrowMarker');

var _ArrowMarker2 = _interopRequireDefault(_ArrowMarker);

var _LinePath = require('./LinePath');

var _LinePath2 = _interopRequireDefault(_LinePath);

var _propsComparisons = require('../../../utils/react/propsComparisons');

var _rafThrottle = require('../../../../common/utils/lib/rafThrottle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

var _browser = require('../../../utils/services/browser');

var _lineConstants = require('../../../../common/lines/lineConstants');

var _lineUiConstants = require('../lineUiConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Utils


// Constants


var NO_MARKER_ID = '';

var startHasChanged = (0, _propsComparisons.hasChanged)('start');
var endHasChanged = (0, _propsComparisons.hasChanged)('end');
var controlPointHasChanged = (0, _propsComparisons.hasChanged)('controlPoint');

var getSvgStyle = function getSvgStyle(bbox) {
    return {
        top: bbox.y - _lineUiConstants.INSET,
        left: bbox.x - _lineUiConstants.INSET,
        width: bbox.width + _lineUiConstants.LINE_HIT_AREA,
        height: bbox.height + _lineUiConstants.LINE_HIT_AREA
    };
};

/**
 * Get the URL for given marker style.
 */
var getMarker = function getMarker(_ref) {
    var edge = _ref.edge,
        edgeStyle = _ref.edgeStyle,
        elementId = _ref.elementId,
        idSuffix = _ref.idSuffix;

    switch (edgeStyle) {
        case _lineConstants.LINE_MARKER_STYLE.ARROW:
            return 'url(#' + (0, _ArrowMarker.getArrowMarkerId)({ edge: edge, elementId: elementId, idSuffix: idSuffix }) + ')';
        default:
            return NO_MARKER_ID;
    }
};

var LineSvg = function (_React$Component) {
    _inherits(LineSvg, _React$Component);

    function LineSvg(props) {
        _classCallCheck(this, LineSvg);

        var _this = _possibleConstructorReturn(this, (LineSvg.__proto__ || Object.getPrototypeOf(LineSvg)).call(this, props));

        _this.getLineBoundingBox = function () {
            if (_this.props.isPresentational && !(0, _browser.isSafari)() || !_this.lineHitArea) return;

            var linePath = _reactDom2.default.findDOMNode(_this.lineHitArea);

            if (!linePath || !linePath.getBBox) return;

            var bbox = linePath.getBBox();
            _this.setState({ bbox: bbox });
        };

        _this.throttledGetLineBoundingBox = (0, _rafThrottle2.default)(_this.getLineBoundingBox);


        _this.state = {
            bbox: null
        };
        return _this;
    }

    _createClass(LineSvg, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.throttledGetLineBoundingBox();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            if (startHasChanged(oldProps, this.props) || endHasChanged(oldProps, this.props) || controlPointHasChanged(oldProps, this.props)) {
                this.throttledGetLineBoundingBox();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                elementEvents = _props.elementEvents,
                start = _props.start,
                controlPoint = _props.controlPoint,
                end = _props.end,
                colorHex = _props.colorHex,
                elementId = _props.elementId,
                idSuffix = _props.idSuffix,
                startStyle = _props.startStyle,
                endStyle = _props.endStyle,
                isPresentational = _props.isPresentational,
                enableDrag = _props.enableDrag,
                disableDrag = _props.disableDrag;
            var bbox = this.state.bbox;


            var startMarker = getMarker({ edge: _lineConstants.LINE_EDGE.start, edgeStyle: startStyle, elementId: elementId, idSuffix: idSuffix });
            var endMarker = getMarker({ edge: _lineConstants.LINE_EDGE.end, edgeStyle: endStyle, elementId: elementId, idSuffix: idSuffix });

            // Transformations
            var svgTranslation = null;
            var groupTranslation = null;
            if ((!isPresentational || (0, _browser.isSafari)()) && bbox) {
                svgTranslation = getSvgStyle(bbox);
                groupTranslation = 'translate(' + (-bbox.x + _lineUiConstants.INSET) + ',' + (-bbox.y + _lineUiConstants.INSET) + ')';
            }

            return _react2.default.createElement(
                'svg',
                { className: 'svg-line', version: '1.1',
                    style: svgTranslation },
                _react2.default.createElement(
                    'defs',
                    null,
                    _react2.default.createElement(_ArrowMarker2.default, { edge: _lineConstants.LINE_EDGE.start, elementId: elementId, idSuffix: idSuffix, colorHex: colorHex }),
                    _react2.default.createElement(_ArrowMarker2.default, { edge: _lineConstants.LINE_EDGE.end, elementId: elementId, idSuffix: idSuffix, colorHex: colorHex })
                ),
                _react2.default.createElement(
                    'g',
                    { transform: groupTranslation, stroke: colorHex },
                    _react2.default.createElement(_LinePath2.default, { className: 'line-path',
                        start: start, end: end,
                        controlPoint: controlPoint,
                        stroke: colorHex,
                        markerStart: startMarker,
                        markerEnd: endMarker }),
                    _react2.default.createElement(_LinePath2.default, _extends({ className: 'line-hit-area',
                        start: start, end: end, controlPoint: controlPoint,
                        stroke: 'transparent',
                        ref: function ref(c) {
                            _this2.lineHitArea = c;
                        },
                        onMouseOver: enableDrag, onMouseOut: disableDrag
                    }, elementEvents))
                )
            );
        }
    }]);

    return LineSvg;
}(_react2.default.Component);

LineSvg.propTypes = {
    elementId: _propTypes2.default.string.isRequired,
    start: _propTypes2.default.object.isRequired,
    end: _propTypes2.default.object.isRequired,
    colorHex: _propTypes2.default.string,
    elementEvents: _propTypes2.default.object,
    idSuffix: _propTypes2.default.string,
    startStyle: _propTypes2.default.string,
    endStyle: _propTypes2.default.string,
    gridSize: _propTypes2.default.number.isRequired,
    controlPoint: _propTypes2.default.object,
    isPresentational: _propTypes2.default.bool,
    enableDrag: _propTypes2.default.func,
    disableDrag: _propTypes2.default.func
};

exports.default = LineSvg;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/svg/LineSvg.js
// module id = 1997
// module chunks = 0